import { Application } from "@hotwired/stimulus"

const application = Application.start()
application.debug = DEBUG
window.Stimulus   = application

export { application }
